import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { useFetch } from "../../lib/useFetch";
import { useLang } from "../../lib/i18n";
import { Img } from "./Img";
import { useGdprPending } from "./GdprPopup";

export const PromoPopup = () => {
  const { data } = useFetch("/public/popups/active");
  const { tr } = useLang();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const gdprPending = useGdprPending();
  const p = gdprPending ? null : (data || []).find((x) => !localStorage.getItem(`aa_popup_${x.id}`));

  useEffect(() => {
    if (!p) return;
    const id = setTimeout(() => setOpen(true), 1500);
    return () => clearTimeout(id);
  }, [p]);

  if (!p) return null;
  const close = () => { localStorage.setItem(`aa_popup_${p.id}`, p.publish_to || "1"); setOpen(false); };
  const go = () => { close(); p.event_id ? nav(`/clinics/${p.event_id}`) : p.link && (window.location.href = p.link); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-2xl overflow-hidden border-0 p-0 [&>button]:hidden" data-testid="promo-popup">
        <div className="grid md:grid-cols-2">
          {p.image && <Img src={p.image} className="h-56 w-full object-cover md:h-full" />}
          <div className="relative flex flex-col gap-4 bg-[#0A2540] p-8 text-white">
            <button onClick={close} className="absolute right-4 top-4 text-white/60 hover:text-white" data-testid="promo-popup-close"><X size={20} /></button>
            <p className="eyebrow">Atlantis Academy</p>
            <DialogTitle className="font-display text-2xl font-bold leading-tight">{tr(p, "title")}</DialogTitle>
            <p className="text-sm leading-relaxed text-white/70">{tr(p, "text")}</p>
            <button onClick={go} className="btn-buoy mt-auto w-fit" data-testid="promo-popup-cta">{tr(p, "cta_label") || "Discover"}</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
